/**
 * 현 페이지에 관련 된 base data 가 변경되면
 * 데이터를 새로 고침한다.
 * 각 페이지에 관련된 base data를 base_data 에 정의한다.
 */
export const base_data = {
  data() {
    return {
      base_data: [],
    }
  },
  created() {
    this.EventBus.$on('changedBaseData', this.handleChangedBaseData);
  },
  beforeDestroy() {
    this.EventBus.$off('changedBaseData', this.handleChangedBaseData);    
  },
  methods: {
    handleChangedBaseData(param) {
      if (!this.base_data.includes(param.table)) { return; }
      this.items = [];    
      this.$nextTick(() =>  this.init());
    }
  }
}